@for (r of (publishRequests$ | async); track r) {
  <div class="request-row" (click)="navToQuest(r)">
    <span>Quest Id: {{r.questId}}</span>
    <span>{{r.updatedAt.toISOString()}}</span>
  </div>
}
